// Module
var code = "<div> <a class=\"flex items-center hover:italic\" href=\"[[ url ]]\" target=\"[[ target ]]\"> <svg view=\"Icon\" data-name=\"icon-link-blank\" class=\"w-5 h-5 mr-5 shrink-0\"></svg> <span class=\"\">[[ text ]]</span> </a> </div> ";
// Exports
export default code;